import posthog from 'posthog-js';

export type { PostHogConfig } from 'posthog-js';
export { PostHogProvider, useFeatureFlagEnabled } from 'posthog-js/react';

export const analytics = {
  identify(id?: string, properties?: Record<string, any>) {
    // @ts-ignore
    window.undicat?.identify?.(id, properties);
    posthog.identify?.(id, properties);
  },
  capture(name: string, properties?: Record<string, any>) {
    // @ts-ignore
    window.undicat?.send?.(name, properties);
    posthog.capture?.(name, properties);
  },
  reset() {
    // @ts-ignore
    window.undicat?.reset?.();
    posthog.reset?.();
  },
};
